module.exports = __webpack_public_path__ + "assets/img/img48.d90f10c2.png";